<div class="emoji-component-container">
  <button
    class="emoji-toggle-btn"
    [class.active]="showEmojiPicker"
    (click)="toggleEmojiPicker($event)"
    [disabled]="disabled"
    [attr.aria-label]="buttonLabel">
    <span>😀</span>
  </button>

  <div
    #emojiPickerContainer
    class="emoji-picker-container"
    *ngIf="showEmojiPicker"
    [@fadeInOut]>
    <emoji-mart
      class="emoji-mart {{emojiMartClass}}"
      [set]="set"
      [emojiSize]="emojiSize"
      [perLine]="perLine"
      [i18n]="emojiI18n"
      [showPreview]="false"
      [skin]="selectedSkin"
      (skinChange)="onSkinChange($event)"
      (emojiSelect)="addEmoji($event)"
      [style]="{ 'height.px': maxEmojiPickerHeight }"
      [title]="emojiPickerTitle"
      [searchIcons]="searchIcons"
      [darkMode]="isDarkMode"
      emojiCategoryNavigation
      appClickOutside
      (clickOutside)="onClickOutside($event)">
    </emoji-mart>
  </div>
</div>
